import Vue from 'vue';
import Multiselect from 'vue-multiselect';

import overviewWidgetAdd from '@/components/overview/widget/widgetAdd/index.vue';
import overviewWidgetEdit from '@/components/overview/widget/widgetEdit/index.vue';
import overviewWidgetRemove from '@/components/overview/widget/widgetRemove/index.vue';

import dateSwitch from '@/components/dateSwitch/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import helpers from '@/mixins/helpers';

import {
  DEFAULT_IMAGE,
} from '@/utils/const';

import Api from '@/utils/api';
import wigetFilters from '@/components/overview/widget/wigetFilters/index.vue';

export default Vue.extend({
  components: {
    Multiselect,
    overviewWidgetAdd,
    overviewWidgetEdit,
    overviewWidgetRemove,
    dateSwitch,
    preloader,
    empty,
    wigetFilters,
  },
  mixins: [
    helpers.general,
  ],
  data() {
    return {
      total: false,
      widgets: [],
      typeHolder: 'Create',
      dateTime: '',
      infoGroupWidget: '',
      defaultImage: DEFAULT_IMAGE,
      industryFields: [],
      scopeList: [{
        id: 'projects',
        name: 'Projects',
      }, {
        id: 'tasks',
        name: 'Tasks',
      }, {
        id: 'reports',
        name: 'Reports',
      }, {
        id: 'jobs',
        name: 'Jobs',
      }],
      switchList: [],
      managerList: [],
      jobTypesList: [],
      sourceLanguageList: [],
      targetLanguageList: [],
      industriesList: [],
      documentTypesList: [],
      steplist: [],

      params: {
        GroupID: this.$route.params.id,
        Name: null,
        Scope: {
          id: 'projects',
          name: 'Projects',
        },
        SourceLanguages: null,
        TargetLanguages: null,
        CreatedOn: null,
        DueDateOn: null,
        Industries: null,
        DocumentTypes: null,
        Status: null,
        JobTypes: null,
        ManagerIDS: null,
        WidgetFilters: null,
        DeadlineRangeSlug: null,
      },
      parseParams: {},
      queryParams: {
        // creation_date: '',
        // managers: '',
        // query: '',
        // scope: '',
        // sourcelanguages: '',
        // statuses: '',
        // targetlanguages: ''
      },

      load: true,
      loadParams: true,
    };
  },
  computed: {
    widgetAdd() {
      return this.checkPermissions('overview', 'overview-widget-add');
    },
    widgetEdit() {
      return this.checkPermissions('overview', 'overview-widget-edit');
    },
    widgetRemove() {
      return this.checkPermissions('overview', 'overview-widget-remove');
    },
  },
  watch: {
    'params.Scope'(newVal) {
      if (newVal) {
        this.getFiltersByName(newVal.name);
      }
    },
  },
  created() {
    this.getWidgets();
    this.getNameGroupWidgets();
    this.getFiltersByName('projects');
  },
  methods: {

    /**
     * Limit count in multiselect
     *
     * @param {Integer} count
     */
    limitText(count) {
      return `and ${count} other`;
    },

    /**
     * Filter on date
     *
     * @param {Object | moment} date
     */
    dateSwitch(date) {
      this.dateTime = '';

      if (date.value[0] !== null) {
        this.dateTime = date.value.join(',');
      }

      this.getWidgets();
    },

    getSwitchListHandler(switchList) {
      this.switchList = switchList;
    },

    /**
     * Refresh all data for create url
     */
    refreshData() {
      this.params = {
        GroupID: this.$route.params.id,
        Name: null,
        Scope: {
          id: 'projects',
          name: 'Projects',
        },
        SourceLanguages: null,
        TargetLanguages: null,
        CreatedOn: null,
        DueDateOn: null,
        Industries: null,
        DocumentTypes: null,
        Status: null,
        JobTypes: null,
        ManagerIDS: null,
      };

      this.parseParams = {};
    },

    /**
     * Refresh all multiselect
     */
    refreshLists() {
      this.managerList = [];
      this.jobTypesList = [];
      this.sourceLanguageList = [];
      this.targetLanguageList = [];
      this.industriesList = [];
      this.documentTypesList = [];
      this.steplist = [];
    },

    /**
     * Get filters using name (projects, tasks and etc)
     *
     * @param {String} name
     */
    getFiltersByName(name) {
      this.refreshLists();

      this.loadParams = true;

      Api.filters
        .get(name)
        .then((response) => {
          const data = response.data;

          if (data.Status) {
            this.managerList = data.Data.Managers;
            this.jobTypesList = data.Data.JobTypes;
            this.sourceLanguageList = data.Data.SLanguages;
            this.targetLanguageList = data.Data.TLanguages;
            this.industriesList = data.Data.IndustryFields;
            this.documentTypesList = data.Data.TextCategories;
            this.steplist = data.Data.Steps;
          }

          this.loadParams = false;
        });
    },

    paramsFilterWidget(filter) {
      Object.keys(filter).forEach((item, ix) => {
        if (filter[item]) {
          this.queryParams[item] = filter[item];
        }
        if (!filter[item] && this.queryParams[item]) {
          this.queryParams[item] = '';
        }
      });

      this.getWidgets();
    },

    /**
     * Get all widgets with filters
     */
    getWidgets() {
      this.load = true;
      this.loadParams = true;
      this.queryParams.creation_Datetime = this.dateTime;
      this.queryParams.overviewGroupID = this.$route.params.id;

      Api.overviews
        .getWidgets(this.$route.params.id, this.queryParams)
        .then((data) => {
          if (data.data.Status) {
            this.widgets = data.data.Data;
            this.widgets.forEach((item, idx) => {
              const route = item.Route != '' ? `?${item.Route}` : '';

              if (item.Scope === 'Tasks') {
                item.RouteFull = `/projects/tile/filters/tasks${route}`;
              } else if (item.Scope === 'Projects') {
                item.RouteFull = `/project-groups/tile/filters/projects${route}`;
              } else if (item.Scope === 'Jobs') {
                item.RouteFull = `/jobs/tile/filters/jobs${route}`;
              } else {
                item.RouteFull = `/reports/filters/reports${route}`;
              }

              if (item.DeadlineRangeSlug) {
                const switchRangeObj = this.switchList.filter((val) => val.slug === item.DeadlineRangeSlug)[0];
                this.$set(item, 'DeadLineRangeName', switchRangeObj.text);
              } else {
                this.$set(item, 'DeadLineRangeName', '');
              }
            });
          }
        })
        .then((_) => this.getTotal())
        .catch((err) => {
          this.$root.$emit('notification', {
            message: `error | ${err}`,
            type: 'error',
            show: true,
          });
        });
    },

    /**
     * Get name group widgets
     */
    getNameGroupWidgets() {
      Api.overviews
        .getWidgetsName(this.$route.params.id)
        .then((data) => {
          if (data.data.Status) {
            this.infoGroupWidget = data.data.Data;
          }
        });
    },

    /**
     * Method for show needed popup
     *
     * @param {String} type
     * @param {Integer} id
     */
    showPopup(type, id) {
      this.typeHolder = type;

      this.loadParams = true;

      if (type === 'Change') {
        const widget = this.widgets.find((item) => {
          return item.ID == id;
        });

        this.params.Name = widget.Name;
        this.params.ID = id;
        this.params.Scope = this.scopeList.find((item) => item.name === widget.Scope);
        this.params.SourceLanguages = widget.SourceLanguages;
        this.params.TargetLanguages = widget.TargetLanguages;
        this.params.Industries = widget.IndustriesData;
        this.params.DocumentTypes = widget.DocumentTypesData;
        this.params.Status = widget.StepsData;
        this.params.JobTypes = widget.JobTypesData;
        this.params.ManagerIDS = widget.ManagersData;
        this.$set(this.params, 'DeadlineRangeSlug', this.getSwitchRangeObject(widget.DeadlineRangeSlug));
        this.loadParams = false;
      } else {
        this.refreshData();
      }

      this.$modal.show('widget');
    },

    getSwitchRangeObject(slug) {
      if (!slug) {
        return null;
      } else {
        const result = this.switchList.filter((item) => item.slug === slug);
        if (result.length === 1) {
          return result[0];
        }
      }
      return null;
    },

    /**
     * Holder params for query widget
     */
    holderWidgets() {
      for (const [key, value] of Object.entries(this.params)) {
        if (value !== null && typeof value === 'object') {
          if (key === 'DeadlineRangeSlug') {
            this.$set(this.parseParams, key, value.slug);
            continue;
          } else if (key === 'Scope') {
            this.$set(this.parseParams, key, value.name);
            continue;
          } else if (key === 'JobTypes') {
            this.$set(this.parseParams, key, value.map((item) => item.Name).join('|'));
            continue;
          }
          this.$set(this.parseParams, key, value.map((item) => item.ID).join('|'));
          continue;
        }
        this.$set(this.parseParams, key, value);
      }

      return this.typeHolder === 'Create' ? this.createWidget() : this.editWidget();
    },

    /**
     * Create widget
     */
    createWidget() {
      const params = Object.assign({}, this.parseParams);
      params.Url = window.location.href.replace(`/${this.$route.params.id}/${this.$route.params.view}`, '');

      Api.overviews
        .createWidgets(params)
        .then((data) => {
          this.holderResponse(data);
        });
    },

    /**
     * Edit widget
     */
    editWidget() {
      Api.overviews
        .editWidgets(this.parseParams)
        .then((data) => {
          this.holderResponse(data);
        });
    },

    /**
     * Holder for getting widgets
     *
     * @param {Array} data
     */
    holderResponse(data) {
      if (data.data.Status) {
        this.getWidgets();
        this.refreshData();

        this.$root.$emit('notification', {
          message: 'Widgets was created!',
          type: 'info',
          show: true,
        });
      } else {
        this.$root.$emit('notification', {
          message: data.data.Message,
          type: 'error',
          show: true,
        });
      }
      this.$modal.hide('widget');
    },

    /**
     * Show dialog window before remove widget
     *
     * @param {Integet} id
     */
    holderRemoveWidget(id) {
      this.$modal.show('dialog', {
        title: '<svg class="icon-delete"><use xlink:href="/img/icons/icons-sprite.svg#icon-delete"/></svg>',
        text: 'Do you really want to remove this widget from the overview? This action cannot be undone.',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeWidget(id);
            this.$modal.hide('dialog');
          },
        },
        {
          title: 'No',
        },
        ],
      });
    },
    getTotal() {
      if (this.widgets.length === 0) {
        this.total = true;
        this.load = false;
        return;
      };
      const fetchAllTotal = async () => {
        const requests = this.widgets.map((widget) => {
          const route = widget.RouteFull.substring(widget.RouteFull.indexOf('?') + 1);
          return Api.filters
            .sendFilters({
              name: 'projects?',
              url: route,
            }, {
              page: 1,
              perPage: 12,
            }).then((res) => {
              const total = res.data.Total;
              widget.total = total;
              this.total = false;
              this.load = true;
              return res;
            });
        });
        return Promise.all(requests);
      };
      fetchAllTotal().then((_) => {
        this.total = true;
        this.load = false;
      });
    },
    /**
     * Remove widget
     *
     * @param {Integet} id
     */
    removeWidget(id) {
      Api.overviews
        .removeWidgets(id)
        .then((data) => {
          if (data.data.Status) {
            this.widgets = this.widgets.filter((value) => {
              return id !== value.ID ? value : '';
            });

            this.$root.$emit('notification', {
              message: 'Widgets was deleted!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
          this.$modal.hide('widget');
        });
    },

    /**
     * Send user on page filter
     *
     * @param {String} url
     */
    goFilter(url) {
      if (url === null) {
        return;
      }

      this.$store.dispatch('SET_FILTERS', url);

      return this.$router.push(url);
    },
  },
});
